import { MyStore } from 'kts-platform-frame/redux';
import { ActionBasic } from 'kts-scaffold-framework/modules';
import ModulesState from './Modules.State';
import { appStore } from 'kts-platform-frame/api';

class ModulesAction extends ActionBasic<ModulesState> {
    // /** 获取我的app应用列表 */
    public getAppList = async () => {
        // 获取app 应用
        const queryMy = await appStore.queryMy(this);
        if(queryMy.er){
            return;
        }
        this.modulesState.appList = queryMy.res.list;
        this.setModulesState();
    }
}

export default new ModulesAction();


// WEBPACK FOOTER //
// ./src/display/platform/MyApp/Modules.Action.ts